import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: "root"
})
export class LanguageService {
    private readonly storageKey = "_lang";
    constructor(
        public translateService: TranslateService
    ) { }

    getSelectedLanguage() {
        return this.translateService.getDefaultLang();
    }

    changeLanguage(lang = "") {
        if (!lang) {
            lang = environment.defaultLang;
        }
        this.translateService.use(lang);
        localStorage.setItem(this.storageKey, lang);
    }

    setDefaultLanguage() {
        let defaultLang = environment.defaultLang;
        if (localStorage.getItem(this.storageKey)) {
            defaultLang = localStorage.getItem(this.storageKey);
        }

        this.translateService.setDefaultLang(defaultLang);
        this.translateService.use(defaultLang);
    }
}
